// Components==============
import React from 'react';
import { SoundType } from '../LetterBlock/LetterBlock';
import DraggableTile from './components/DraggableTile/DraggableTile';
import DroppableTile from './components/DroppableTile/DroppableTile';
import './DragNDropTile.module.scss';
// =========================

type Props = {
    index: number;
    droppableCondition: boolean;
    setTileBarState: React.Dispatch<React.SetStateAction<SoundType[]>>;
    tileBarState: SoundType[];
    id: string;
    tilePartIsFinished: boolean;
};

export default function DragNDropTile({
    index,
    droppableCondition,
    setTileBarState,
    id,
    tilePartIsFinished,
    tileBarState,
}: Props) {
    return (
        <DroppableTile
            isDroppable={droppableCondition}
            setTileBarState={setTileBarState}
            tileBarState={tileBarState}
            id={id}
            index={index}
            done={tilePartIsFinished}
        >
            <DraggableTile
                tilePartIsFinished={tilePartIsFinished}
                tileBarState={tileBarState}
                index={index}
                id={id}
                isDraggable={tileBarState[index] !== '' && droppableCondition}
            />
        </DroppableTile>
    );
}
